import React, { useEffect, useState, useCallback, createRef } from "react";
import clsx from "clsx";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
    Drawer,
    CssBaseline,
    List,
    Divider,
    IconButton,
    ListItem,
    ListItemIcon,
    ListItemText,
    useTheme,
    CircularProgress,
} from "@material-ui/core";
import { toast } from "react-toastify";
import { MuiThemeProvider } from "@material-ui/core/styles";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import PlusCircleFilled from "@material-ui/icons/AddCircle";
import FileTextFilled from "@material-ui/icons/InsertDriveFile";
import HomeIcon from "@material-ui/icons/Home";
import AddContractIcon from "@material-ui/icons/NoteAdd";

import Header from "../Components/Header";
import Footer from "../Components/Footer";
import Loading from "../Components/Loading";
import ModalFormSegurado from "./ModalFormSegurado";
import ListaSegurados from "./ListaSegurados/ListaSegurados";

import { hubConnection, onImportacaoState } from "../Store/Actions/API/signalrActions";
import { setOpenMenu, setOpenSeguradoForm } from "../Store/Actions/Reducer/menuActions";
import { listarResultados } from "../Store/Actions/API/resultadosActions";
import { encryptObject } from "../Utils/utils";
import temaMenu from "../Styles/Temas/temaMenu";
import { layoutStyles as useStyles } from "./styles";
import "../Styles/SCSS/sidebar.scss";

export const historyRef = createRef()

function Layout(props) {
    const history = useHistory();
    const classes = useStyles();
    const theme = useTheme();
    const dispatch = useDispatch();
    const contratoAceito = JSON.parse(localStorage.getItem("_20ex20"));

    const { children } = props;
    const { openMenu } = useSelector((state) => state.menu);
    const { isLoading, mensagemLoading } = useSelector((state) => state.main);

    historyRef.current = history;

    // Menu
    const [connection, setConnection] = useState({});
    const [isLoadingNovoContrato, setIsLoadingNovoContrato] = useState(false);
    const [selectedCpf, setSelectedCpf] = useState(null);

    const initialRender = useCallback(() => {
        if (!connection.importacao) {
            const importacao = hubConnection("importacao");
            setConnection((prev) => ({ ...prev, importacao }));
        } else {
            dispatch(onImportacaoState(connection.importacao));
        }
    }, [connection, dispatch]);

    const getCpfSegurado = useCallback(() => {
        const { pathname } = history.location;
        if (pathname.startsWith("/segurado/")) {
            const cpf = pathname.match(/\d+/);
            return cpf && cpf[0];
        }
        return null;
    }, [history.location]);

    useEffect(() => {
        initialRender();
        return () => {
            connection &&
                connection.importacao &&
                connection.importacao.stop();;
        };
    }, [initialRender, connection]);

    useEffect(() => {
        // if (!contratoAceito) {
        //     history.push("/contrato");
        // }
    }, [history, contratoAceito]);

    useEffect(() => {
        setSelectedCpf(getCpfSegurado());
    }, [getCpfSegurado, history]);   

    const handleListarPropostaContrato = () => {
        const filtro = { modulo: "INSSPessoaFisica" };
        window.open(
            `${process.env.REACT_APP_GESTAO_CONTRATOS_URL}/home?f=${encryptObject(
                filtro
            )}`,
            "_blank"
        );
    };

    const handleNovaPropostaContrato = async () => {
        if (!isLoadingNovoContrato) {
            const cpfSegurado = getCpfSegurado();

            if (cpfSegurado) {
                setIsLoadingNovoContrato(true);

                let credito = 0;

                try { 
                    let dados = await listarResultados({ cpf: cpfSegurado, pagina: 0, itensPorPagina: 20 });

                    if (dados) {
                      const { creditoTotalSelic } = dados;
                      credito = creditoTotalSelic ?? 0;
                    }
    
                    const data = {
                      modulo: "INSSPessoaFisica",
                      cnpj: cpfSegurado,
                      credito: credito,
                    };
    
                    window.open(
                      `${
                        process.env.REACT_APP_GESTAO_CONTRATOS_URL
                      }/novo/tipo-template?d=${encryptObject(data)}`,
                      "_blank"
                    );
                } catch (e) {
                    console.log(e)
                    toast.error("Ocorreu um erro ao tentar gerar novo contrato")
                }

                setIsLoadingNovoContrato(false);                
            }
        }
    }

    const handleOpenMenu = (open) => {
        dispatch(setOpenMenu(open));
    }

    const handleOpenSeguradoForm = (open, cpf = null) => {
        dispatch(setOpenSeguradoForm(open, cpf));
    }

    const redirectTo = (path) => {
        if (window.location.pathname !== path) {
            handleOpenMenu(path === "/home");
            history.push(path);
        }
    }

    return (
        <>
            <ModalFormSegurado />
            <div className={classes.root}>
                <CssBaseline />
                <MuiThemeProvider theme={temaMenu}>
                    <Header openMenu={openMenu} handleOpenMenu={handleOpenMenu} />
                    <Drawer
                        className={classes.drawer}
                        variant="persistent"
                        anchor="left"
                        open={openMenu}
                        classes={{
                            paper: classes.drawerPaper,
                        }}
                    >
                        <div className={classes.drawerHeader}>
                            <IconButton onClick={() => handleOpenMenu(false)}>
                                {theme.direction === "ltr" ? (
                                    <ChevronLeftIcon />
                                ) : (
                                    <ChevronRightIcon />
                                )}
                            </IconButton>
                        </div>
                        <Divider />
                        <List>
                            <ListItem button key="Home" onClick={() => redirectTo("/home")}>
                                <ListItemIcon>
                                    <HomeIcon color="primary" style={{ color: "#D4BFF9" }} />
                                </ListItemIcon>
                                <ListItemText primary="Início" />
                            </ListItem>
                            <ListItem
                                button
                                key="Cadastrar_Segurado"
                                onClick={handleOpenSeguradoForm}
                            >
                                <ListItemIcon>
                                    <PlusCircleFilled
                                        color="primary"
                                        style={{ color: "#D4BFF9" }}
                                    />
                                </ListItemIcon>
                                <ListItemText primary="Cadastrar Segurado" />
                            </ListItem>
                            <ListItem
                                button
                                key="Listar_Propostas"
                                onClick={handleListarPropostaContrato}
                            >
                                <ListItemIcon>
                                    <FileTextFilled
                                        color="primary"
                                        style={{ color: "#D4BFF9" }}
                                    />
                                </ListItemIcon>
                                <ListItemText primary="Listar propostas" />
                            </ListItem>
                            {selectedCpf && (
                                <ListItem
                                    button
                                    key="NovaPropostaContrato"
                                    onClick={handleNovaPropostaContrato}
                                >
                                    <ListItemIcon>
                                        {!isLoadingNovoContrato && <AddContractIcon
                                            color="primary"
                                            style={{ color: "#D4BFF9" }}
                                        />}
                                        {isLoadingNovoContrato && (
                                            <CircularProgress
                                                size={25}
                                                className={classes.addContractLoading}
                                            />
                                        )}
                                    </ListItemIcon>
                                    <ListItemText primary="Nova Proposta ou Contrato" />
                                </ListItem>
                            )}
                            <Divider />
                        </List>
                        <ListaSegurados />
                    </Drawer>
                </MuiThemeProvider>
                <main
                    className={clsx(classes.content, {
                        [classes.contentShift]: openMenu,
                    })}
                >
                    <div className={classes.drawerHeader} />
                    {children}
                </main>
                <Footer resize={openMenu} />
            </div>
            {isLoading && <Loading zIndex2={true} text={mensagemLoading ?? ''} />}
        </>
    );

}

export default Layout;
